/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} New_Project_Drop_Zone_HintInputs */



/**
* | output |
* | --- |
* | "or click to browse your device" |
*
* @param {New_Project_Drop_Zone_HintInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const new_project_drop_zone_hint = /** @type {((inputs?: New_Project_Drop_Zone_HintInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<New_Project_Drop_Zone_HintInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("ou cliquez pour parcourir votre appareil")
	if (locale === "de") return /** @type {LocalizedString} */ ("oder klicken Sie hier, um Ihr Gerät zu durchsuchen")
	if (locale === "it") return /** @type {LocalizedString} */ ("oppure fai clic per sfogliare il tuo dispositivo")
	if (locale === "ru") return /** @type {LocalizedString} */ ("или нажмите, чтобы просмотреть содержимое вашего устройства")
	if (locale === "es") return /** @type {LocalizedString} */ ("o haga clic para explorar su dispositivo")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("或点击浏览您的设备")
	if (locale === "ja") return /** @type {LocalizedString} */ ("またはクリックしてデバイスを参照")
	if (locale === "hi") return /** @type {LocalizedString} */ ("या अपने डिवाइस को ब्राउज़ करने के लिए क्लिक करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("ou clique para navegar no seu dispositivo")
	return /** @type {LocalizedString} */ ("or click to browse your device")
});